// extracted by mini-css-extract-plugin
export var bodySections = "_57-8";
export var gray = "_57-7";
export var green = "_57-4";
export var iconContainer = "_57-9";
export var iconWidgetContainer = "_57-1";
export var phoneIcon = "_57-2";
export var red = "_57-5";
export var statusDot = "_57-3";
export var widgetContainer = "_57-0";
export var yellow = "_57-6";